import { ProductsDependenciesService } from "@/api/services/products-dependencies.service";
import { DataService } from "@/api/services/data.service";
import { DropdownTypes } from "@/constants/constants";

const getProductTransitionGroups = ({ commit }: any, params?: { page?: number; limit?: number; search?: string }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.getProductTransitionGroups(params)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const createProductTransitionGroup = (_: any, { data }: { data: any }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.createProductTransitionGroup(data)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const patchProductTransitionGroup = (_: any, { id, data }: { id: number; data: any }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.patchProductTransitionGroup(id, data)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const getDropdownsByCustomerTypeField = (_: any, { customerType, field }: { customerType: string; field: string }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.getDropdownsByCustomerTypeField({ customerType, field })
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const getCustomerTypes = () => {
	return DataService.findDropdownData({ name: DropdownTypes.CUSTOMER_TYPES });
};

const getBundleConfigurations = (_: any, { aggrupationId }: { aggrupationId: number }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.getBundleConfigurations(aggrupationId)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const getListAggrupations = ({ commit }: any, params?: { page?: number; limit?: number; search?: string }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.getListAggrupations(params)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const getAggrupations = () => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.getAggrupations()
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const createAggrupation = (_: any, { data }: { data: { name: string } }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.createAggrupation(data)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const patchAggrupation = (_: any, { aggrupationId, data }: { aggrupationId: number; data: { name: string } }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.patchAggrupation(aggrupationId, data)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const deleteAggrupation = (_: any, { aggrupationId }: { aggrupationId: number }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.deleteAggrupation(aggrupationId)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const getCombinationDropdowns = (_: any, { groupId, field }: { groupId: number; field: string }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.getCombinationDropdowns({ groupId, field })
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const createCombination = (_: any, { data }: { data: any }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.createCombination(data)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const patchCombination = (_: any, { id, data }: { id: number; data: any }) => {
	return new Promise((resolve, reject) => {
		ProductsDependenciesService.patchCombination(id, data)
			.then((response) => resolve(response.data))
			.catch(reject);
	});
};

const getMobileTypes = () => {
	return DataService.findDropdownData({ name: DropdownTypes.PRODUCT_TRANSITION_COMBINATION_MOBILE_TYPES });
};

export default {
	getProductTransitionGroups,
	createProductTransitionGroup,
	patchProductTransitionGroup,
	getDropdownsByCustomerTypeField,
	getCustomerTypes,
	getAggrupations,
	getBundleConfigurations,
	getCombinationDropdowns,
	createCombination,
	patchCombination,
	getMobileTypes,
	getListAggrupations,
	deleteAggrupation,
	createAggrupation,
	patchAggrupation
};
